import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./Firebase/AuthProvider";




function Login() {

    const { running, user, UserLogin } = useContext(AuthContext);

    const usrname = useRef();
    const pswd = useRef();

    const [error, setError] = useState()

    const navigate = useNavigate()

    return (
    <div className="login"> 
    <div style={{position:"absolute", fontSize:"2rem", color:"white", top:"50px"}} className="hori_center"
        onClick={()=>{
            navigate("/")
        }}
        type = "button"
    >Maviinci Admin panel</div>
        <div className="login_wrapper both_center">            
            <div className="left_align">Username</div>
            <input placeholder="Username" type="text" ref={usrname}
                onChange={(e)=>{
                    setError(null)
                }}
            /><br/><br/>
            <div>Password</div>
            <input placeholder="password" type="password" ref={pswd}
                onChange={(e)=>{
                    setError(null)
                }}
            /><br/><br/>
            <button className="Butt1 hori_center"
                onClick={()=>{
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    // emailPattern.test(email);
                    
                    const email = usrname.current.value;
                    const password = pswd.current.value;
                    
                    if(email && emailPattern.test(email) && password){

                    
                    const u = UserLogin(usrname.current.value, pswd.current.value)
                    console.log(u)
                    
                    if(u){
                        navigate("/admin/0")    
                    } else {
                        setError("Invalid credentials")
                    }
                    } else {
                        setError("Invalid credentials")
                    }
                }}
            >
                Login
            </button>
            {error && <div style={{textAlign:"center", "color":"red"}}>{error}</div>}
        </div>
    </div> );
}

export default Login;